(function (angular, window) {
    'use strict';

    /**
     * Validates if the promo codes are valid or not.
     */
    window.THF.Angular.API
        .factory('PromoCodeModel', ['$http', '$q', function ($http, $q) {
            var PromoCodeModel = function () {

            };

            PromoCodeModel.prototype = {
                validatePromoCode: function (code) {
                    var deferred = $q.defer();
                    var req = {
                        method: 'GET',
                        url: '/api/v1/data/promo-code/?code='+code
                    };

                    $http(req)
                        .success(function (response) {
                            deferred.resolve(response);
                        })
                        .error(function () {
                            deferred.reject();
                        });
                    return deferred.promise;
                }
            };

            return new PromoCodeModel();
        }]);

})(angular, window);
